export default "__VITE_ASSET__CmebBXZ___"